import {
  Autocomplete,
  FormControl,
  FormLabel,
  TextField,
  Typography,
} from '@mui/material';

import { useDAL } from '@/contexts/useDAL';

import { EmptySelect } from './emptySelect';

export const ResourceGroupSelect = ({
  accountId,
  resourceGroup,
  onChange,
  includeAll,
}: {
  accountId?: string;
  resourceGroup?: string;
  onChange: (resourceGroup: string) => void;
  includeAll?: boolean;
}) => {
  if (!accountId) {
    return <EmptySelect title={title} />;
  }

  return (
    <InnerResourceGroupSelect
      accountId={accountId}
      resourceGroup={resourceGroup}
      onChange={onChange}
      includeAll={includeAll}
    />
  );
};

const title = 'Resource Group';

const InnerResourceGroupSelect = ({
  accountId,
  resourceGroup,
  onChange,
  includeAll,
}: {
  accountId: string;
  resourceGroup?: string;
  onChange: (resourceGroup: string) => void;
  includeAll?: boolean;
}) => {
  const dal = useDAL();
  const { data: body } = dal.restore.azureRestoreConfig.useListResourceGroups(
    accountId,
    includeAll
  );

  if (!body?.resourceGroups?.length) {
    return <EmptySelect title={title} />;
  }

  return (
    <FormControl size='small' className='flex-1'>
      <FormLabel>{title}</FormLabel>
      <Autocomplete
        clearOnBlur
        size='small'
        value={
          body?.resourceGroups.find((rg) => rg.name === resourceGroup) || null
        }
        onChange={(event, newValue) => onChange(newValue?.name || '')}
        getOptionLabel={(option) => option.name}
        renderOption={(props, group) => (
          <li {...props} key={group.name}>
            <Typography className='py-[4px]'>{group.name}</Typography>
          </li>
        )}
        renderInput={(params) => {
          return (
            <TextField
              {...params}
              placeholder='Select'
              label=''
              slotProps={{ inputLabel: { shrink: true } }}
            />
          );
        }}
        options={body.resourceGroups}
      />
    </FormControl>
  );
};
